var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuzzyMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M18 6v16h4V6Zm-8 8H6v8h4zm6-4h-4v12h4zm6 14H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h4v-2a2 2 0 0 1 2-2h4V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    id: "g16",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path)"
    },
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)",
    id: "g14",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1
    },
    d: "M-1-1h30v30H-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuzzyMembership);
export default __webpack_public_path__ + "static/media/fuzzy-membership.1914e358fce97755be41896b5a4358b2.svg";
export { ForwardRef as ReactComponent };